export const login = (private_key: string) =>
  localStorage.setItem('privateKey', private_key)
